/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Calculation } from '../models/calculation';
import { UuiDv4 } from '../models/uui-dv-4';

@Injectable({
  providedIn: 'root',
})
export class CalculationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listCalculations
   */
  static readonly ListCalculationsPath = '/calculations';

  /**
   * get list of calculations for current user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCalculations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCalculations$Response(params?: {

    /**
     * changes get logic for todo page
     */
    toDo?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Calculation>>> {

    const rb = new RequestBuilder(this.rootUrl, CalculationService.ListCalculationsPath, 'get');
    if (params) {
      rb.query('toDo', params.toDo, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Calculation>>;
      })
    );
  }

  /**
   * get list of calculations for current user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCalculations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCalculations(params?: {

    /**
     * changes get logic for todo page
     */
    toDo?: boolean;
  },
  context?: HttpContext

): Observable<Array<Calculation>> {

    return this.listCalculations$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Calculation>>) => r.body as Array<Calculation>)
    );
  }

  /**
   * Path part for operation saveCalculation
   */
  static readonly SaveCalculationPath = '/calculations';

  /**
   * upsert Calculation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveCalculation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveCalculation$Response(params: {
    body: Calculation
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UuiDv4>> {

    const rb = new RequestBuilder(this.rootUrl, CalculationService.SaveCalculationPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UuiDv4>;
      })
    );
  }

  /**
   * upsert Calculation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveCalculation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveCalculation(params: {
    body: Calculation
  },
  context?: HttpContext

): Observable<UuiDv4> {

    return this.saveCalculation$Response(params,context).pipe(
      map((r: StrictHttpResponse<UuiDv4>) => r.body as UuiDv4)
    );
  }

  /**
   * Path part for operation listCalculationsByArchivedState
   */
  static readonly ListCalculationsByArchivedStatePath = '/calculations/active';

  /**
   * get list of calculations by ArchivedState for current user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCalculationsByArchivedState()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCalculationsByArchivedState$Response(params: {

    /**
     * gets Calculations of specific state
     */
    archivedState: string;

    /**
     * changes get logic for todo page
     */
    toDo?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Calculation>>> {

    const rb = new RequestBuilder(this.rootUrl, CalculationService.ListCalculationsByArchivedStatePath, 'get');
    if (params) {
      rb.query('archivedState', params.archivedState, {});
      rb.query('toDo', params.toDo, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Calculation>>;
      })
    );
  }

  /**
   * get list of calculations by ArchivedState for current user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCalculationsByArchivedState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCalculationsByArchivedState(params: {

    /**
     * gets Calculations of specific state
     */
    archivedState: string;

    /**
     * changes get logic for todo page
     */
    toDo?: boolean;
  },
  context?: HttpContext

): Observable<Array<Calculation>> {

    return this.listCalculationsByArchivedState$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Calculation>>) => r.body as Array<Calculation>)
    );
  }

  /**
   * Path part for operation listArchivedCalculationsByYear
   */
  static readonly ListArchivedCalculationsByYearPath = '/calculations/archived/{year}';

  /**
   * Lists Calculations Filterd by Year and optional by Month
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listArchivedCalculationsByYear()` instead.
   *
   * This method doesn't expect any request body.
   */
  listArchivedCalculationsByYear$Response(params: {

    /**
     * gets Calculations of specific state
     */
    year: string;

    /**
     * changes get logic for todo page
     */
    month?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Calculation>>> {

    const rb = new RequestBuilder(this.rootUrl, CalculationService.ListArchivedCalculationsByYearPath, 'get');
    if (params) {
      rb.path('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Calculation>>;
      })
    );
  }

  /**
   * Lists Calculations Filterd by Year and optional by Month
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listArchivedCalculationsByYear$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listArchivedCalculationsByYear(params: {

    /**
     * gets Calculations of specific state
     */
    year: string;

    /**
     * changes get logic for todo page
     */
    month?: number;
  },
  context?: HttpContext

): Observable<Array<Calculation>> {

    return this.listArchivedCalculationsByYear$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Calculation>>) => r.body as Array<Calculation>)
    );
  }

  /**
   * Path part for operation getCalculation
   */
  static readonly GetCalculationPath = '/calculations/{id}';

  /**
   * get calculation by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCalculation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCalculation$Response(params: {

    /**
     * UUID of the Calculation to get
     */
    id: UuiDv4;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Calculation>> {

    const rb = new RequestBuilder(this.rootUrl, CalculationService.GetCalculationPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Calculation>;
      })
    );
  }

  /**
   * get calculation by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCalculation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCalculation(params: {

    /**
     * UUID of the Calculation to get
     */
    id: UuiDv4;
  },
  context?: HttpContext

): Observable<Calculation> {

    return this.getCalculation$Response(params,context).pipe(
      map((r: StrictHttpResponse<Calculation>) => r.body as Calculation)
    );
  }

  /**
   * Path part for operation updateCalculationArchivedState
   */
  static readonly UpdateCalculationArchivedStatePath = '/calculations/{id}';

  /**
   * update archive state of calculation by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCalculationArchivedState()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateCalculationArchivedState$Response(params: {

    /**
     * UUID of the Calculation to update
     */
    id: UuiDv4;

    /**
     * value of new archive state
     */
    archivedState: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CalculationService.UpdateCalculationArchivedStatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('archivedState', params.archivedState, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * update archive state of calculation by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCalculationArchivedState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateCalculationArchivedState(params: {

    /**
     * UUID of the Calculation to update
     */
    id: UuiDv4;

    /**
     * value of new archive state
     */
    archivedState: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.updateCalculationArchivedState$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteCalculation
   */
  static readonly DeleteCalculationPath = '/calculations/{id}';

  /**
   * delete calculation by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCalculation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCalculation$Response(params: {

    /**
     * UUID of the Calculation to delete
     */
    id: UuiDv4;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CalculationService.DeleteCalculationPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * delete calculation by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCalculation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCalculation(params: {

    /**
     * UUID of the Calculation to delete
     */
    id: UuiDv4;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteCalculation$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
